import React, { useState, useEffect, useContext } from 'react'
import * as dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { Layout } from '../../atomic-components/organisms/layout'
import { Seo } from '../../atomic-components/organisms/seo'
import { TabsCasino } from '../../atomic-components/molecules/tabsCasino'
import { ContentWrapper } from '../../atomic-components/atoms/contentWrapper'
import { SearchProvider } from '../../context/searchProvider'
import { SearchModal } from '../../atomic-components/molecules/searchModal'
import { optedInPromotions } from '../../adapters/promotions'
import { AuthContext } from '../../context/authProvider'
import { PromotionsList } from '../../atomic-components/molecules/promotionsList'
import { useCasinoApiData } from '../../hooks/graphqlStaticQuery/useCasinoApiData'
import { usePromotionsApiData } from '../../hooks/graphqlStaticQuery/usePromotionsApiData'

dayjs.extend(utc)

const PromotionsPage = ({
  pageContext: { casinoSlug, type, paths, navContext },
}) => {
  const { searchModalGames, tabsCasinoData } = useCasinoApiData(type)

  const { isLoggedIn } = useContext(AuthContext)
  const { promos } = usePromotionsApiData()

  const [promotions, setPromotions] = useState(promos)

  useEffect(() => {
    const fetchOptedInPromotions = async () => {
      if (isLoggedIn) {
        const response = await optedInPromotions()
        if (response.ok) {
          setPromotions((promos) => {
            const promosWithOptedIn = promos.map((promo) => {
              if (response.data[promo.promotion_identifier]) {
                promo.isOptedIn = true
              }
              return promo
            })
            return promosWithOptedIn
          })
        }
      }
    }
    fetchOptedInPromotions()
  }, [isLoggedIn])

  const filteredPromotions = type
    ? promotions.filter(
        (e) =>
          e.type == type.replaceAll('-', '') ||
          e.sub_type == type.replaceAll('-', '')
      )
    : promotions

  return (
    <SearchProvider>
      <Layout navContext={navContext}>
        <SearchModal data={searchModalGames} />

        <ContentWrapper gap="1em" gapMobile="0.75em">
          <TabsCasino
            content={tabsCasinoData}
            casinoSlug={casinoSlug}
            paths={paths}
          />
          <PromotionsList promotions={filteredPromotions} />
        </ContentWrapper>
      </Layout>
    </SearchProvider>
  )
}

export default PromotionsPage

export const Head = ({ pageContext: { lang }, location: { pathname } }) => {
  return (
    <Seo
      title={lang?.seo?.promotions_title}
      description={lang?.seo?.promotions_description}
      hrefLangPage={'promotions'}
      pathname={pathname}
    />
  )
}
